import React from 'react';
import { Notification } from 'commons/components';
import { NotificationTypes } from 'commons/services';

function EmptyStateNotifications(): JSX.Element {
  return (
    <Notification
      listeningToTypes={[NotificationTypes.KycIdentityValidated]}
      tagOnLoad={[
        [
          NotificationTypes.KycIdentityValidated,
          'pago-nube-identidad-validada-view',
        ],
      ]}
    />
  );
}

export default EmptyStateNotifications;
